import chroma from 'chroma-js';
import { StylesConfig } from 'react-select';

export interface SeverityOption {
  readonly value: string;
  readonly label: string;
  readonly color: string;
}

export const colorStyles: StylesConfig<SeverityOption, true> = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    const color = chroma(data.color);
    const choiceBgColor = color.alpha(0.8).css();
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? choiceBgColor
        : isFocused
        ? data.color
        : undefined,
      color: isDisabled ? '#ccc' : 'black',
      // : isSelected
      //     ? chroma.contrast(choiceBgColor, data.color) > 2
      //         ? data.color
      //         : 'black'
      //     : data.color,
      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled
          ? isSelected
            ? data.color
            : color.alpha(0.3).css()
          : undefined,
        color: 'black',
      },
      ':hover': {
        ...styles[':hover'],
        backgroundColor: data.color,
        color: chroma.contrast(data.color, 'white') > 1 ? 'white' : 'black',
      },
    };
  },
  // selected badges styles
  multiValue: (styles, { data }) => {
    const color = chroma(data.color);
    return {
      ...styles,
      backgroundColor: color.alpha(0.9).css(),
    };
  },
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: chroma.contrast(data.color, 'white') > 2 ? 'white' : 'black',
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    // color: data.color,
    color: 'black',
    ':hover': {
      backgroundColor: data.color,
      color: 'white',
    },
  }),
};
